<template>
	<div class="time-input">
		<div class="header">
			<p class="title">
				{{ labels.title }}
			</p>
			<button @click="handleCancel">
				<Icon
					icon-name="e-remove"
					size="lg"
				/>
			</button>
		</div>
		<MobileTimePickerControl
			:max-minutes="maxMinutes"
			:value="{ minutes, seconds }"
			@input="onTimeUpdate"
		/>
		<div class="actions">
			<button
				class="confirm"
				@click="handleConfirm"
			>
				{{ labels.confirm }}
			</button>
		</div>
	</div>
</template>

<script>
import { padStart } from 'lodash-es';
import MobileTimePickerControl from '@components/MobileTimeInput/MobileTimePickerControl';

export default {
	name:       'MobileTimeInput',
	components: { MobileTimePickerControl },
	props:      {
		value: {
			type:     String,
			required: true,
		},
		labels: {
			type:    Object,
			default: () => ({
				title:   'Title',
				confirm: 'Save',
			}),
		},
		maxMinutes: {
			// inclusive
			type:    Number,
			default: 120,
		},
	},
	data() {
		return {
			minutes: 0,
			seconds: 0,
		};
	},
	created() {
		this.initFields();
	},
	methods: {
		initFields() {
			if (!this.value) {
				return;
			}
			const parts = this.value.split(':');
			this.minutes = Number.parseInt(parts[0]);
			this.seconds = parts[1] ? Number.parseInt(parts[1]) : 0;
		},
		onTimeUpdate({ minutes, seconds }) {
			this.minutes = minutes;
			this.seconds = seconds;
		},
		handleCancel() {
			this.$emit('cancel');
		},
		handleConfirm() {
			const value = `${padStart(this.minutes, 2, '0')}:${padStart(this.seconds, 2, '0')}`;
			this.$emit('input', value);
		},
	},
};
</script>

<style lang="scss" scoped>
$control-item-height: 50px;
$control-visible-item-count: 5;

.time-input {
	background: var(--color-grey-900);
}

.header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 24px 16px;
	border-bottom: 1px solid var(--color-grey-850);

	.title {
		font-size: 24px;
	}
}

.time-picker-control {
	padding: 24px 16px;
	font-size: 24px;

	.control-wheels {
		display: flex;
		align-items: center;
		width: 100%;
		height: $control-visible-item-count * $control-item-height;
	}

	.minutes,
	.seconds {
		flex: 1;
		text-align: center;
		height: 100%;
		overflow: auto;
		scroll-snap-type: mandatory;
		scroll-snap-type: y mandatory;
		scroll-snap-points-y: repeat($control-item-height);
		ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.option {
			display: flex;
			align-items: center;
			justify-content: center;
			height: $control-item-height;
			scroll-snap-align: center;
		}
	}

	.overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 0 16px;
		pointer-events: none;
		line-height: 0;

		.shadow-top,
		.shadow-bottom {
			flex: 1;
			width: 100%;
		}
		.shadow-top {
			background: linear-gradient(180deg, var(--color-rgb-grey-900) 0%, rgba(var(--color-rgb-grey-850), 0) 100%);
		}
		.shadow-bottom {
			background: linear-gradient(180deg, var(--color-rgb-grey-900) 0%, rgba(var(--color-rgb-grey-850), 0) 100%);
			transform: rotate(-180deg);
		}

		.separator {
			flex: 0 0 1;
			display: flex;
			align-items: center;
			justify-content: center;
			height: $control-item-height;
			width: 100%;
			border-top: 1px solid var(--color-grey-850);
			border-bottom: 1px solid var(--color-grey-850);
		}
	}
}

.actions {
	display: flex;
	padding: 16px;

	button {
		font-size: 16px;
	}

	button.confirm {
		flex: 1;
		padding: 14px;
		border-radius: 2px;
		text-align: center;
		background: var(--color-hype-yellow);
		color: var(--color-shadow-grey);

		&:hover {
			background: --lighten-color-hype-yellow;
		}
	}
}
</style>
